import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = string;

export const useDefaultObservableString = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectString extends BehaviorSubject<CurrentType> {}
